import OrganizationDataService from "@/services/OrganizationDataService";

async function checkCustomerCodeRepeat(id,data){
    return await OrganizationDataService.checkCustomerCode(id,data)
    .then(res => {
        return res.data
    })
}

export default checkCustomerCodeRepeat;